import CommentCardMiniSimple from '@/component/CommentCard/SimpleMinCard';
import SelectTag from '@/component/SelectTags/SelectTags';
import { useDetailPageStore } from '@/page/detail/store';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { View, Text, ScrollView, TouchableWithoutFeedback } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import ArrowRight from '@/assets/icon_detail/kibt_post_music_right_gray.png';
import { KImage } from '@/component/RtlLayout';
import { Box } from '@kibt/meta-ui-krn';
import { useQuery } from '@/hooks/useQuery';
import { jumpToComment } from '@/common/biz/jump';
import { $k18n } from '@/common/i18n';
import { scaleW } from '@/common/style';
import { isAndroid } from '@kibt/krn-utils';
import { logClickCommentImageButton, logClickCommentImageLine } from '../../../logger2.0';
import { getQuery, SCENE } from '@/common/const';
import { Comment } from '../../../api';
import { useCallApp } from '@/common/callApp';

export const CommentImage = (props: { ifClick?: boolean }) => {
    const pageRawData = useDetailPageStore(s => s.pageRawData);
    const comments = (pageRawData?.comments || []) as Comment[];
    const tagCnt = pageRawData?.tagCnt || [];
    const { callApp } = useCallApp();

    return comments?.length >= 2 ? (
        <View
            style={{"height":"100.00000000000001rem","width":"100.00000000000001rem","position":"relative","alignItems":"center","justifyContent":"center"}}>
            <LinearGradient
                style={{"position":"absolute","top":"0rem","left":"0rem","width":"100%","height":"100%"}}
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 1 }}
                colors={['#feded3', '#fef5f2']}
            />
            <View
                style={{
                    // 1. 沉浸式商详页是从屏幕顶部开始绘制的，所以需要留出更大的空间，防止navbar遮挡CommentImage的图文
                    // 2. 安卓的半屏推全屏容器不支持沉浸式，所以需要需要把非沉浸式商详这里的展示调整一下
                    width: scaleW(376),
                    height: isAndroid && getQuery('isHalf') === '1' ? scaleW(296) : scaleW(260),
                    paddingHorizontal: scaleW(16),
                    paddingVertical: scaleW(12),
                    backgroundColor: '#fff',
                    borderRadius: 8,
                    overflow: 'hidden',
                }}>
                <View>
                    <Text
                        style={{"fontSize":"4.830917874396135rem","fontWeight":"700","color":"#000","lineHeight":"5.555555555555556rem","marginBottom":"0.9661835748792271rem"}}>
                        {$k18n({ id: 'k_1050288', text: '好评如潮' })}
                    </Text>
                    <SelectTag tagList={tagCnt} disabled from={'commentImage'} />
                </View>
                <View
                    style={{"flex":1}}>
                    <ScrollView
                        style={{"flex":1,"position":"relative"}}
                        showsVerticalScrollIndicator={false}>
                        {comments.map((comment, index) => {
                            return (
                                <View>
                                    <View
                                        style={{
                                            width: '100%',
                                            height: scaleW(1),
                                            backgroundColor: '#F2F2F2',
                                            marginTop: index === 0 ? scaleW(0) : scaleW(12),
                                            marginBottom: scaleW(12),
                                        }}
                                    />
                                    <Box
                                        activeOpacity={1}
                                        onPress={() => {
                                            callApp({ pageId: 'ecomm_commodity_detail' });
                                        }}>
                                        <CommentCardMiniSimple {...comment} />
                                    </Box>
                                </View>
                            );
                        })}
                    </ScrollView>
                    <LinearGradient
                        style={{"position":"absolute","bottom":"0rem","width":"100%","height":"3.8647342995169085rem"}}
                        colors={['rgba(255, 255, 255, 0)', 'rgba(255, 255, 255, 1)']}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 0, y: 1 }}
                    />
                </View>
            </View>

            <View
                style={{"position":"absolute","bottom":"1.9323671497584543rem","alignSelf":"flex-start"}}>
                <TouchableWithoutFeedback
                    onPress={() => {
                        callApp({ pageId: 'ecomm_commodity_detail' });
                    }}>
                    <View
                        style={{"justifyContent":"center","alignItems":"center","flexDirection":"row","height":"8.695652173913045rem","marginLeft":"4.5893719806763285rem"}}>
                        <Text
                            style={{"lineHeight":"5.797101449275363rem","color":"rgba(0,0,0,0.64)"}}>
                            {$k18n({ id: 'k_1050287', text: '查看更多评价' })}
                        </Text>
                        <KImage source={ArrowRight} style={{"width":"5.797101449275363rem","height":"5.797101449275363rem"}} />
                    </View>
                </TouchableWithoutFeedback>
            </View>
        </View>
    ) : null;
};
